export class DropdownValueObject {
  value: string;
  label: string;

  constructor(value: string, label?: string | null) {
    this.value = value;
    this.label = label ? label : value?.toString();
  }
}
